const getUser = () => {
 const user = localStorage.getItem("user");
 return user !== null ? JSON.parse(user) : null;
};

export default getUser;